export default __webpack_public_path__ + "static/media/bg-smart-home-2.62753abf.jpg";